import { merge } from "lodash-es";
import { sharedTranslations } from "../../shared-translations.js";
import { sunsetSpecificTranslations, type ISunsetSpecificTranslations } from "../sunset/index.js";

export const splittySpecificTranslations = {
  "html-metadata": {
    "brand-name": "Splitty",
  },
} as const;

export type ISplittySpecificTranslations = typeof splittySpecificTranslations & ISunsetSpecificTranslations;

const splittyTranslations = merge({}, sharedTranslations, splittySpecificTranslations, sunsetSpecificTranslations);
export const translations = {
  dictionary: splittyTranslations,
  language: "EN",
};
